// extracted by mini-css-extract-plugin
var _1 = "Q1joB__button";
var _2 = "Q1joB__num";
var _3 = "Q1joB__numContent";
var _4 = "Q1joB__numContent_lost";
var _5 = "Q1joB__numContent_selected";
var _6 = "Q1joB__numContent_won";
var _7 = "Q1joB__tile";
export { _1 as "button", _2 as "num", _3 as "numContent", _4 as "numContent_lost", _5 as "numContent_selected", _6 as "numContent_won", _7 as "tile" }
